/* eslint-disable @typescript-eslint/no-unused-vars */
import { createReducer } from '@reduxjs/toolkit'
import * as actions from '../actions'
import { UserLoginResponse } from '@services/auth.services'

type StateType = {
  user?: UserLoginResponse
}

const initialState: StateType = {}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actions.loginByEmail.fulfilled, (state, action) => {
      // eslint-disable-next-line no-console
      state.user = action.payload
    })
    .addCase(actions.passwordForgot.fulfilled, (state, action) => {
      // eslint-disable-next-line no-console
    })
    .addCase(actions.passwordReset.fulfilled, (state, action) => {
      // eslint-disable-next-line no-console
    })
    .addCase(actions.logOut, (state) => {
      state.user = undefined
    })
})
